export enum ColumnType {
  COLOR = "color",
  STATUS = "status",
  TEXT = "text",
  NUMBER = "numbers",
  NUMERIC = "numeric",
  PEOPLE = "people",
  PERSON = "person",
  MULTIPLE_PEOPLE = "multiple_person",
  EMAIL = "email",
  DATE = "date",
  HOUR = "hour",
  RATING = "rating",
  PHONE = "phone",
  DROPDOWN = "dropdown",
  TIMELINE = "timeline",
  LINK = "link",
  LONG_TEXT = "long_text",
  FILE = "file",
  CHECKBOX = "checkbox",
  LOCATION = "location",
  BOARD_RELATION = "board_relation",
  DOC = "doc",
  TAG = "tags",
}
